import { createAction, props } from '@ngrx/store';
import { IRejectionReason } from '../models/rejection-reason.model';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';

export const loadWithdrawalRejectionReasons = createAction(
  '[WithdrawalRejectionReason] Load WithdrawalRejectionReasons'
);

export const loadWithdrawalRejectionReasonsSuccess = createAction(
  '[WithdrawalRejectionReason] Load WithdrawalRejectionReasons Success',
  props<{ response: IRejectionReason[] }>()
);

export const loadWithdrawalRejectionReasonsFailure = createAction(
  '[WithdrawalRejectionReason] Load WithdrawalRejectionReasons Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);
